import { render, staticRenderFns } from "./PaymentsList.vue?vue&type=template&id=5c3e939b&scoped=true"
import script from "./PaymentsList.vue?vue&type=script&lang=js"
export * from "./PaymentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3e939b",
  null
  
)

export default component.exports